export default __webpack_public_path__ + "static/media/g2022-12.42820185.jpeg";